export type LocaleType = 'en-US' | 'ja';
